import RestService from '../services/rest';

async function getAllProductTelecom(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/productTelecom/all?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getProductsTelecomOptions(productId, search) {
  return RestService.getAuthenticated(
    `panel/productTelecom/productsOptions?productId=${productId}&search=${search}`,
  );
}

async function getResultFormulaProduct(id, meters = 1, points = 1) {
  return RestService.getAuthenticated(
    `panel/productTelecom/resultFormulaProduct?id=${id}&meters=${meters}&points=${points}`,
  );
}


async function createProductTelecom(newProductTelecom) {
  return RestService.postAuthenticated(
    'panel/productTelecom/create', newProductTelecom,
  );
}

async function updateProductTelecom(updProductTelecom) {
  return RestService.putAuthenticated(
    'panel/productTelecom/update', updProductTelecom,
  );
}

export default {
  getAllProductTelecom,
  getProductsTelecomOptions,
  getResultFormulaProduct,
  createProductTelecom,
  updateProductTelecom,
};
